/**
 * Lazy-loads the Framer Motion animation features feature set so list pages
 * do not pull the full motion runtime into the critical path until used.
 */
import { LazyMotion, domAnimation } from 'framer-motion';
import type { ReactNode } from 'react';

export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <LazyMotion features={domAnimation} strict>
      {children}
    </LazyMotion>
  );
}
